import { render, staticRenderFns } from "./VImport.vue?vue&type=template&id=5d6bf266&"
import script from "./VImport.vue?vue&type=script&lang=js&"
export * from "./VImport.vue?vue&type=script&lang=js&"
import style0 from "./VImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports